import { Col, Container, Row } from "reactstrap";

const Scholarship = () => {
  return (
    <section className="section" id="scholarship">
      <Container>
        <Row className="">
          <Col xs='12' lg='5'>
          <img
            src="assets/images/scholarship.webp" 
            alt="students-apply-for-scholarship-illustration"
            className="img-fluid" 
            loading="lazy" 
          />
          </Col>
          <Col xs='12' lg='7'>
            <h1 className="mt-3 mt-lg-0 mb-3">Info Beasiswa</h1>
            <div>
              <h2><b>Scholarships & Bursaries</b></h2>
              <p>
                Griffith College punya beberapa dukungan beasiswa untuk 
                mahasiswa internasional, termasuk pengurangan biaya berdasarkan 
                prestasi akademik dan bursaries.               
              </p>
              <p>Salah satu nya:</p>
              <ul>
                <li> Beasiswa 50% Untuk Bachelor Degree dan Master Degree.</li>
              </ul>
            </div>  
            <p className="note">*Untuk beasiswa paling tepat, hubungi tim admissions Griffith College langsung karena kriteria & tipe beasiswa sering berubah.</p>         
          </Col>          
        </Row>
      </Container>
    </section>
  );
};

export default Scholarship;